import React from 'react';

const SlackGrantAccessButton = (props) => (
    <div className={`slack-access-button mt3 ${props.className || ''}`} onMouseDown={props.onMouseDown}>
        <img className="mr1" height="22" src="/img/icons/share/slack-icon.png" />
        Grant Slack access
    </div>
);

export default SlackGrantAccessButton;
